export const Spacer = () => {
  return <div style={{ height: 24, width: 24 }} />;
};
